import React from 'react';
import { useFirebase } from '../contexts/FirebaseContext';
import { CashTipContainer } from './CashTipContainer';
import { DollarSign } from 'lucide-react';

export const PersonalCashTipsPage: React.FC = () => {
  const { tenantId, role, user } = useFirebase();
  const isSuperAdmin = user?.email?.toLowerCase() === 'admin@growezy.ai';
  const isAdminOrManager = role === 'admin' || role === 'manager' || role === 'owner' || isSuperAdmin;

  if (!tenantId) {
    return null;
  }

  return (
    <div className="p-4 md:p-8 max-w-7xl mx-auto space-y-6">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 border-b border-gray-200 pb-5">
        <div>
          <h1 className="text-2xl md:text-3xl font-black text-gray-900 tracking-tight">Report Cash Tips</h1>
          <p className="text-gray-500 text-sm mt-1">
            Submit direct cash tips received for IRS reporting and payroll taxes.
          </p>
        </div>
      </div>

      {/* Main Form & Personal Submissions */}
      <CashTipContainer 
        tenantId={tenantId} 
        isAdminOrManager={isAdminOrManager} 
        userEmail={user?.email || ''} 
      />
    </div>
  );
};
